import { useState } from "react";

import { Col, Form, Row } from "react-bootstrap";

import InputNumber from "../../../components/inputs/InputNumber";
import Switchrs from "../../../components/inputs/Switchrs";

const Forminputandswitch = ({ arrydata, handeDataInput, update }) => {

    const handelValue = (status, name, value) => {

        arrydata.map(item => {

            switch (name) {

                case item.id:

                    handeDataInput({ status, optionId: item.id, value: parseInt(value) })

                    break;

                default:
                    break;
            }
        })
    }
    return (
        <>
            {arrydata.length > 0 ?
                arrydata.map((item, index) => <Inputandswitch key={index} update={update} item={item} handelValue={handelValue} />)
                : null}
        </>
    );
}

export default Forminputandswitch;


export function Inputandswitch({ item, handelValue, update }) {

    const finditem = update ? update.filter(find => find.optionId === item.id)[0] : []

    const [disabled, setDisabled] = useState(finditem ? true : false)

    const [inputvalue, setInputvalue] = useState(1)

    const handelInput = (name, value) => {
        setInputvalue(value)
        handelValue(disabled, name, value);
    }
    const handelSwich = (event) => {
        setDisabled(event.target.checked);
        handelValue(event.target.checked, item.id, inputvalue)
    }

    return (
        <Row>
            <Col className='d-flex align-items-center' >
                <Form.Check
                    type="switch"
                    id={item.id}
                    label={item.title}
                    checked={disabled}
                    onChange={handelSwich}

                />
            </Col>

            <Col>
                <InputNumber
                    name={item.id}
                    label={item.title}
                    defaultValue={finditem ? finditem.value : inputvalue}
                    disabled={finditem ? !disabled : !disabled}
                    Placeholder={item.inputTitle}
                    handelValue={handelInput}
                />
            </Col>
        </Row>
    )
}
